import { h } from '@atomify/jsx';
import { Button } from '@atoms/button/button';
import { BPDFunctionalSvg } from '@atoms/svg/svg';

interface AreaSubscriptionNavigationBarInterface {
    ctaLabel?: string;
    ctaAction?: Function;
    helperText?: string;
    checkmark?: boolean;
    classes?: string;
}

export const AreaSubscriptionNavigationBar = (data: AreaSubscriptionNavigationBarInterface) => (
    <div class={`c-area-subscription-navigation-bar ${data.classes}`.trim()}>
        <span
            class={`u-color--positive u-margin-right-1 u-hidden--xs u-hidden--sm${
                !data.checkmark ? ' u-hidden' : ''
            }`}
            js-hook-area-subscription-navigation-checkmark>
            <BPDFunctionalSvg
                name="icons-checkmark"
                attr={{ style: { width: '1.2rem', height: '0.8rem' } }}
            />
        </span>
        <p
            class="u-body-normal u-margin-right-3 u-hidden--xs u-hidden--sm"
            js-hook-area-subscription-navigation-helper-text>
            {data.helperText}
        </p>
        <Button
            width="full-width-mobile"
            label={data.ctaLabel || ''}
            onClick={data.ctaAction}
            hook="area-subscription-navigation-cta"
            hasLoading
            disabled
        />
    </div>
);
